import useConsultants from "@/hooks/useConsultants";
import { useState } from "react";

export default function JobPageContacts({ job }) {
  const consultants = useConsultants();
  const [consultant] = useState(
    consultants.find((c) => c.email === job?.consultant_email),
  );

  return (
    <div className="text-purple font-normal flex flex-col gap-10 items-center lg:items-start">
      {job?.consultant_name && (
        <>
          <span className="text-center md:text-left text-3xl">
            Need to know more about this role?
          </span>
          <div className="flex flex-col sm:flex-row gap-7 items-center">
            {consultant?.image && (
              <img
                src={consultant?.image}
                alt="contact"
                className="max-w-[144px] max-h-[144px] object-cover"
                style={{ width: "140px", height: "140px" }}
              />
            )}
            <div className="flex flex-col text-xs md:text-base gap-1">
              <span className="text-base md:text-2xl">
                {job?.consultant_name}
              </span>
              <div className="flex flex-col">
                <p>
                  {" "}
                  <a
                    className="hover:!opacity-50"
                    href={`mailto:${job?.consultant_email}`}
                    target="_blank"
                  >
                    {job?.consultant_email}
                  </a>
                </p>
                {consultant && (
                  <p>
                    {" "}
                    <a
                      className="hover:!opacity-50"
                      href={`tel:${consultant?.telephone}`}
                      target="_blank"
                    >
                      {consultant?.telephone}
                    </a>
                  </p>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
